import type { RouteProps } from "@shared/react-router-dom";
import type { Flipper } from "@shared/types/flipper";
import { wildcardPath } from "@shared/utils";
import { ReloadPage } from "@unauthenticated/catalog/components";
import { openCatalogRoutes } from "@unauthenticated/catalog/data/openCatalogRoutes";
import { LazyCatalogPage } from "@unauthenticated/catalog/scenes/CatalogPage/LazyCatalogPage";

interface Route extends Omit<RouteProps, "children"> {
  key: string;
  flipper?: Flipper;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const baseRoutes = (flippers: Flipper[]): Route[] => [
  {
    path: wildcardPath(openCatalogRoutes.catalog),
    key: "catalogPage",
    element: <LazyCatalogPage />,
  },
];

const defaultRoute: Route = {
  key: "defaultRoute",
  element: <ReloadPage />,
  path: "*",
};

const routeActive = (route: Route, flippers: Flipper[]) => {
  return !route.flipper || flippers.includes(route.flipper);
};

const activeRoutes = (allRoutes: Route[], flippers: Flipper[]) => {
  return (
    allRoutes
      .filter(route => routeActive(route, flippers))
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .map(({ flipper, ...route }) => route)
  );
};

const routes = (flippers: Flipper[]): Route[] => {
  const allRoutes = [...baseRoutes(flippers), defaultRoute];
  return activeRoutes(allRoutes, flippers);
};

export type { Route };
export { routes, routeActive, activeRoutes };
